<template lang="pug">
.c-paginator
    a(:class="{'c-paginator-disabled': currentPage === 1}", @click="prevPage").c-paginator-prev
      | Предыдущая
    |
    span.c-paginator-list
      template(v-for="(page, index) in pages")
        a(@click="changeOffset(page.number)", v-if="page.type === 'page'",
          :class="{'c-paginator-active': page.number == currentPage}").c-paginator-item {{ page.number }}
        span.c-paginator-dot(v-if="page.type === 'dot'") …
    |
    a(:class="{'c-paginator-disabled': pagesCount === currentPage}", @click="nextPage").c-paginator-next
      | Следующая

</template>

<script>
/* eslint-disable */
export default {
  props: {
    offset: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  computed: {
    pagesCount() {
      return Math.ceil(this.total / this.limit) || 1;
    },
    currentPage() {
      return Math.floor((this.offset + this.limit) / this.limit) || 1;
    },
    pages() {
      const pagesList = [];
      const pagesCount = this.pagesCount;
      const current = this.currentPage;
      const maxPageNumbers = 10;
      const dot = { type: 'dot' };

      if (pagesCount > maxPageNumbers) {
        const start = Math.max((current - (maxPageNumbers / 2) + 1), 1);
        for (let i = 0; i < maxPageNumbers && start + i <= pagesCount; i++) {
          pagesList.push({
            type: 'page',
            number: start + i
          });
        }
        if (current + (maxPageNumbers / 2) < pagesCount) {
          pagesList[pagesList.length - 2] = dot;
          pagesList[pagesList.length - 1] = {
            type: 'page',
            number: pagesCount
          };
        }
        if (pagesList.length < maxPageNumbers) {
          let start = pagesList[0].number;
          const need = maxPageNumbers - pagesList.length;
          for (let i = 0; i < need; i++) {
            pagesList.unshift({
              type: 'page',
              number: start - (i + 1)
            });
          }
        }
        if (current - (maxPageNumbers / 2) > 0) {
          pagesList[1] = dot;
          pagesList[0] = {
            type: 'page',
            number: 1
          };
        }
      } else {
        for (let i = 0; i < pagesCount; i++) {
          pagesList.push({
            type: 'page',
            number: i + 1
          });
        }
      }

      return pagesList;
    }
  },
  methods: {
    prevPage() {
      if (this.currentPage !== 1) {
        this.changeOffset(this.currentPage - 1);
      }
    },
    nextPage() {
      if (this.pagesCount !== this.currentPage) {
        this.changeOffset(this.currentPage + 1);
      }
    },
    changeOffset(page) {
      this.$emit('page', page);
    }
  }
};
</script>

<style lang="sass">
$color_grey: grey
.c-paginator
  text-align: justify
  display: flex
  align-items: center
  &-next &-prev &-list
    display: inline-block
    white-space: nowrap
    text-decoration: none
    color: inherit

  &-list
    text-align: center

  &-item
    cursor: pointer
    display: inline-block
    border-radius: 24rem
    text-decoration: none
    color: inherit
    margin: 5px
    padding: 5px
    background: beige

  &-dot
    display: inline-block
    color: $color_grey

  &-active
    color: #f00

  &-disabled
    color: $color_grey
    & & *
      cursor: default

</style>
